import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CtaShare } from '@components/partials/cta-share/cta-share';
import { UiModule } from '@components/ui/ui-module';
import { Page, Scan } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'lgb-page-binder',
  imports: [
    UiModule,
    CtaShare
  ],
  templateUrl: './page-binder.html',
  styleUrl: './page-binder.css',
})
export class PageBinder {
  //service
  readonly route=inject(ActivatedRoute);
  readonly binderS=inject(BinderService);

  //data
  readonly share=signal<string>(null);
  readonly page=signal<Page>(null);
  readonly scan=signal<Scan>(null);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);

    this.route.queryParamMap.subscribe(params => this.share.set(params.get('share')));

    this.route.paramMap
      .pipe(
        switchMap(params => this.binderS.getDetailPage(params.get('ident'), this.share()))
      )
      .subscribe(response => {
        this.scan.set(response.scan);
        this.page.set(response.page);
        this.loading.set(false);
      });
  }
}
